export const skinColors = {
  1 : '#f6f6f6',
  2 : '#1b1b1b',
  3 : '#3267a3',
  4 : '#60a0c8',
  5 : '#2baf9e',
  6 : '#3ab278',
  7 : '#8bbb4e',
  8 : '#ff6d00',
  9 : '#c73a3a',
  10 : '#956f46',
  11 : '#654771',
  12 : '#666666',
  13 : '#fb0584',
};
